// @flow
import Cafeteria from './Cafeteria';

export default Cafeteria;
